
export function capitalizeFirstLetter(name) {
  if (!name) return '';
  return name
    .split(' ') 
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
    .join(' ');
}

  export function formatIndianCurrency(price){
    return price.toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2
    });
};

  